import { AiOutlineCloudUpload } from 'react-icons/ai';
import { CgCalendarToday } from 'react-icons/cg';
import { HiDocumentReport } from 'react-icons/hi';
import {
  MdDriveFolderUpload,
  MdFeaturedPlayList,
  MdRoomPreferences,
  MdSummarize,
  MdSupervisorAccount,
} from 'react-icons/md';
const tiles = [
  {
    sNo: 1,
    link: '/common/company_roles_responsibilities_listOfProcedures?documentType=clause3ListOfProcedure',
    isLink: true,
    icon: <MdDriveFolderUpload size="5rem" color="#003566" />,
    p: 'LIST OF',
    span: 'PROCEDURE',
    isIcon: true,
  },
  {
    sNo: 19,
    link: '/common/4mSummaryList',
    isLink: true,
    icon: <MdSummarize size="5rem" color="#003566" />,
    p: '4M',
    span: 'SUMMARY',
    isIcon: true,
  },
  {
    sNo: 19,
    link: `/common/abnormalityHandlingProcedureUpload/?documentType=4MAndAbnormalityHandlingProcedure&heading=4M AND ABNORMALITY HANDLING PROCEDURE`,
    isLink: true,
    icon: <HiDocumentReport size="5rem" color="#003566" />,
    p: '4M  & Abnormality',
    span: 'Handling Procedure',
    isIcon: true,
  },

  // {
  //   sNo: 6,
  //   link: 'https://uc.secure.aqua.mushinlabs.com',
  //   isLink: true,
  //   clauseNo: 3,
  //   icon: <MdFeaturedPlayList size="5rem" color="#135089" />,
  //   p: '4M MONITERNING',
  //   span: 'REPORTS',
  //   isIcon: true,
  // },
  {
    sNo: 4,
    link: '/common/breakDownAnalysisGraph/dashboardList',
    isLink: true,
    icon: <MdRoomPreferences size="5rem" color="#003566" />,
    p: 'BREAKDOWN ANALYSIS',
    span: 'GRAPH',
    isIcon: true,
  },
  {
    sNo: 2,
    link: '/common/breakdownAnalysisSheet',
    isLink: true,
    icon: <CgCalendarToday size="5rem" color="#212529" />,
    p: 'BREAKDOWN ANALYSIS',
    span: 'SHEET',
    isIcon: true,
  },
];

export default tiles;
